import http from '../HttpRequest.js'
class TakeScreenshotAPI {
    get( URL = "", params = {} ) {
        return http.get(`api/take-screenshot/${URL}`, {params})
    }
	post(URL = "", params = {}) {
        var formData = new FormData();
        if (params) {
            for (var key in params) {
                formData.append(key, params[key])
            }
        }
        return http.post(`api/take-screenshot/${URL}`, formData)
    }
}
export default new TakeScreenshotAPI()